import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import UpdateUserStatusButton from 'modules/members/components/UpdateUserStatusButton';
import SectionDivider from 'modules/common/components/SectionDivider';
import MemberProfileInfoBanner from 'modules/members/components/MemberProfileInfo';
import MemberTransactions from 'modules/members/components/MemberTransactions';
import LimitWidth from 'modules/common/components/LimitWidth';
import Loader from 'modules/common/components/Loader';

import {
  TopButtonsWrapper,
  BackLink,
  LoaderWrapper,
  extenedPageContainerStyle,
} from './MemberProfileComponent.style';

const MemberProfileComponent = props => {
  const { member } = useSelector(state => state.members);

  return (
    <LimitWidth extendStyle={extenedPageContainerStyle}>
      {member.status === status.FETCHING && (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      )}
      {member.status === status.SUCCESS && member?.details?.data?.userEmail && (
        <>
          <TopButtonsWrapper>
            <BackLink href="/members" />
            <UpdateUserStatusButton />
          </TopButtonsWrapper>
          <SectionDivider gap={16} />
          <MemberProfileInfoBanner />
          <SectionDivider gap={16} />
          <MemberTransactions {...props} />
        </>
      )}
    </LimitWidth>
  );
};

export default MemberProfileComponent;
